import type { LineString, MultiLineString, MultiPolygon, Point, Polygon } from 'geojson';

export enum EntityType {
  PIPELINE = 'PIPELINE',
  SEGMENT = 'SEGMENT',
  REGION = 'REGION',
  BASIN = 'BASIN',
  STATE = 'STATE',
  COUNTY = 'COUNTY',
  ZONE = 'ZONE',
  ASSET = 'ASSET',
}

export type Geometry = Point | LineString | MultiLineString | Polygon | MultiPolygon;

export interface Entity {
  _id: string;
  type: EntityType;
  name: string;
  externalId?: string;
  geometry?: Geometry;
  paths: string[];
}
